/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Remark = defineComponent({
  name: "Remark",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Remark.install = function (app) {
  app.component(Remark.name, Remark);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M31.3056 13.798L21.4997 23.6034L20.7034 26.4394L23.5398 25.6431L33.3597 15.8238L31.3056 13.798ZM33.7301 11.3737L35.7841 13.3994L36.9273 12.2563L34.8873 10.2165L33.7301 11.3737ZM36.8407 6.51307L40.6307 10.3028C41.7096 11.3817 41.7096 13.131 40.6307 14.2098L25.9983 28.8415L25.6283 29.2114L25.1247 29.3528L19.6631 30.8862C17.5873 31.4689 15.6738 29.5553 16.2566 27.4796L17.7901 22.0184L17.9315 21.5147L18.3014 21.1448L32.9339 6.51307C34.0127 5.43429 35.7618 5.43428 36.8407 6.51307ZM12 38.2857C11.211 38.2857 10.5714 37.6461 10.5714 36.8571V11.1429C10.5714 10.3539 11.211 9.71429 12 9.71429H24.8763V5.71429H12C9.00186 5.71429 6.57141 8.14474 6.57141 11.1429V36.8571C6.57141 39.8553 9.00187 42.2857 12 42.2857H36C38.9981 42.2857 41.4286 39.8553 41.4286 36.8571V23.9412H37.4286V36.8571C37.4286 37.6461 36.789 38.2857 36 38.2857H12Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Remark.render = render;

export { Remark as default };
